import React, { useRef } from "react";
import { Typography } from "@material-tailwind/react";
import { Breadcrumbs } from "@material-tailwind/react";
import { Link } from "react-router-dom";
import { FcCancel } from "react-icons/fc";
import {
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
} from "@material-tailwind/react";
import { useState, useEffect } from "react";
import Loading from "../../COMPONENTS/Loading/Loading";
import { ChevronUpDownIcon } from "@heroicons/react/24/outline";
import { RxDotsVertical } from "react-icons/rx";
import {
  Card,
  CardHeader,
  Button,
  CardBody,
  CardFooter,
  IconButton,
  Tooltip,
} from "@material-tailwind/react";
import SidebarTop from "../SidebarTop";
import { GrMoney } from "react-icons/gr";
import { IoAddSharp } from "react-icons/io5";
import { FiEdit } from "react-icons/fi";
import Transaction from "../../../API/tourisme/transaction/index";
import { Depense, Sale, TransactionProps } from "../../../props";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";

const TABLE_ROWS = [
  {
    name: "Hotel Lorenzo",
    email: "info@gmail.com",
    portable: "+225 01 00 00 00 00",
    titre: "Achat de congelateur",
    date: "22/10/2024",
    lieu: "Abidjan, Cote d'ivoire",
    montant: "100000",
    section: "Restaurant",
    categorie: "Depense",
  },
  {
    name: "Adjagbe christia",
    email: "info@gmail.com",
    portable: "+225 01 00 00 00 00",
    titre: "Location de vehicule",
    date: "29/05/2024",
    lieu: "Abidjan, Cote d'ivoire",
    montant: "30000",
    section: "Vehicule",
    categorie: "Vente",
  },
  {
    name: "Africa digitalizer",
    email: "info@gmail.com",
    portable: "+225 01 00 00 00 00",
    titre: "Achat de ticket touristique",
    date: "06/09/2024",
    lieu: "Abidjan, Cote d'ivoire",
    montant: "400000",
    section: "Tourisme",
    categorie: "Depense",
  },
  {
    name: "Murphy micheal",
    email: "info@gmail.com",
    portable: "+225 01 00 00 00 00",
    titre: "Location d'hebergement",
    date: "03/01/2024",
    lieu: "Abidjan, Cote d'ivoire",
    montant: "30000",
    section: "Hebergement",
    categorie: "vente",
  },
  {
    name: "Mon bon sejour",
    email: "info@gmail.com",
    portable: "+225 01 00 00 00 00",
    titre: "Achat de ticket de cinema ",
    date: "22/10/2024",
    lieu: "Abidjan, Cote d'ivoire",
    montant: "9000000",
    section: "loisirs",
    categorie: "Depense",
  },
  {
    name: "vavoua eric",
    email: "info@gmail.com",
    portable: "+225 01 00 00 00 00",
    titre: "Restauration ",
    date: "22/10/2024",
    lieu: "Abidjan, Cote d'ivoire",
    montant: "9000000",
    section: "Restaurant",
    categorie: "vente",
  },
];

function Liste() {

  // interface Som{
  //   unique_prices?:number
  // }
  localStorage.setItem("url", JSON.stringify("/Dashboard/Transation"));

  const [records, setRecords] = useState([]);
  const [filterdRecords,setFilteredRecords] = useState([])
  const [somme,setSomme] = useState({})
  const dateRef = useRef(null);
  const [activeButton, setActiveButton] = useState("depense");
  const [visible, setVisible] = useState(false);
  const [transactions,setTransactions] = useState([])
  const [currentPage,setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [recordsToDisplay, setRecordsToDisplay] = useState([]);
  const [filteredTransactions, setFilteredTransactions] = useState([]);
  const itemsPerPage = 2; 
  //const totalPages = Math.ceil(records.length / itemsPerPage); // Calculer le nombre total de pages

 //const startIndex = (currentPage - 1) * itemsPerPage; // Calculer l'index de début
 //const endIndex = startIndex + itemsPerPage; // Calculer l'index de fin
 //const recordsToDisplay = records.slice(startIndex, endIndex); // Obtenir les enregistrements à afficher pour la page actuelle
 
 const prevPage = () => {
    if( currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
 }

 const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
 }
 const [data, setData] = useState(() => {
    // getting stored value
    const saved = localStorage.getItem("data");
    const initialValue = saved !== null ? JSON.parse(saved) : null;
    return initialValue;
  });

  const [loading, setLoading] = useState(true);
  let authUser = JSON.parse(localStorage.getItem('data') || 'null');

  const filteredTransaction = (data)=>{
    const selectedDate = dateRef.current?.value
     if(!selectedDate) return data;
     return data.filter((filt)=>{
        const recordDate = filt.date.split(" ")[0]
        return recordDate === selectedDate
     })
  }

  const getAllDepense = () => {
    Transaction.getDepenses(authUser?.userId)
      .then((res) => {
        if (res.data.status === 200) {
          const allData = res.data.depenses;
          const filtered = filteredTransaction(allData);

          setRecords(filtered);              // affichage
          setFilteredRecords(allData);      // base pour re-filtrage
          setSomme(res.data.somme);
          setTotalPages(Math.ceil(allData.length / itemsPerPage)); // Calculer le nombre total de pages
          //setRecordsToDisplay(allData.slice(startIndex, endIndex)); // Obtenir les enregistrements à afficher pour la page actuelle
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };


  useEffect(() => {
    getAllDepense();

    //const timer = setTimeout(() => {
    // Après 5 secondes, masquer le spinner et rediriger l'utilisateur
    //setLoading(false);
    //}, 2000); // 5000 millisecondes = 5 secondes

    // Nettoyer le timer si le composant est démonté avant la fin du délai
    //return () => clearTimeout(timer);
  }, []);


  const getAllTransaction = () => {
       Transaction.getAllTransaction(authUser?.userId)
                   .then((res)=>{
                       if(res.data.status === 200)
                       {
                          setFilteredTransactions(res.data.transactions);
                        const filtered = filteredTransaction(res.data.transactions);
                         setTransactions(filtered);
                       }
                   })
                   .catch((err)=>{
                       console.log("Erreur lors de l'appel a l'API ",err)
                   })
  }

  const handleTransaction = () => {
    setActiveButton("transaction");
    getAllTransaction();   
  }         

  const handleDepense = () => {
    setActiveButton("depense");
    getAllDepense();
  };

  const handleVente = () => {
    setActiveButton("vente");

    Transaction.getVentes(authUser?.userId)
      .then((res) => {
        if (res.data.status === 200) {
          const allData = res.data.ventes;
          const filtered = filteredTransaction(allData);

          setRecords(filtered);             // affichage
          setFilteredRecords(allData);     // base pour filtre
          setTotalPages(Math.ceil(allData.length / itemsPerPage)); // Calculer le nombre total de pages
          //setRecordsToDisplay(allData.slice(startIndex, endIndex)); // Obtenir les enregistrements à afficher pour la page actuelle
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };


  const handleDelete =  (idTrans, id)=>{

    Transaction.DeleteTransaction(idTrans, id)
            .then((res)=>{
                if(res.data.status === 200)
                {
                  setRecords(res.data.depenses);
                  setSomme(res.data.somme)
                  toast.success(res.data.message)
                  return;
                }

                if(res.data.status === 201)
                {
                  setRecords(res.data.ventes)
                  toast.success(res.data.message)
                  return;
                }
            }).catch((err)=>{
              console.log("Erreur lors de l'appel a l'API ",err)
            })
  }

  const handleDateChange = (e) => {
    const selectedDate = e.target.value;

    const filteredByDate = filterdRecords.filter((filt) => {
      const recordDate = filt.date.split(' ')[0];
      return recordDate === selectedDate;
    });

    const filteredTransactionsByDate = filteredTransactions.filter((filt) => {
      const recordDate = filt.date.split(' ')[0];
      return recordDate === selectedDate;
    });

    setTransactions(filteredTransactionsByDate);

    setRecords(filteredByDate);
  };

  const handleReset = () => {
    if (dateRef.current) {
      dateRef.current.value = ""; // réinitialise le champ date
    }
    // Recharge les données initiales selon le bouton actif
    if (activeButton === "depense") {
      handleDepense(); // recharge les dépenses
    } else if (activeButton === "vente") {
      handleVente(); // recharge les ventes
    }else if (activeButton === "transaction") {
      getAllTransaction(); // recharge les transactions
    }
  };

  useEffect(() => {
    const start = (currentPage - 1) * itemsPerPage;
    const end = start + itemsPerPage;
    if(activeButton === "transaction") {
        setTotalPages(Math.ceil(transactions.length / itemsPerPage)); // Calculer le nombre total de pages
        setRecordsToDisplay(transactions.slice(start, end));
        return;
    }
   setTotalPages(Math.ceil(records.length / itemsPerPage)); // Calculer le nombre total de pages
   setRecordsToDisplay(records.slice(start, end));
}, [activeButton,currentPage, records,transactions]);






  // function isSale(item: Depense | Sale): item is Sale {
  //   return 'LastName' in item;
  // }

const {t} = useTranslation()
const TABLE_HEAD = ["Action",t("Categorie"),t("Client"),t("Titre & Section"),t("Date & lieu"),t("Montant")];
const TABLE_HEAD_TRANSACTION = ["Client", "Date", "Montant", "Titre annonce", "Note", "Status", "Action"];

  return (
    <div className="flex flex-row bg-[#eeee]">
      {loading ? (
        // Afficher le spinner tant que loading est true
        <Loading />
      ) : (
        <>
          <div className="w-screen  barre_scroll h-screen">
            {/* sidebar top  */}
            <ToastContainer/>
            <SidebarTop />
            {/* navbar top gris*/}
            <div className="bg-[#f7f7f7] sm:h-10 s:h-14 mt-[50px]">
              <Breadcrumbs>
                <Link to="" className="opacity-60 md:text-base s:text-xs">
                  Transaction
                </Link>
                <Link
                  to="/Dashboard/Transation/Revenu"
                  className="md:text-base s:text-xs"
                >
                  {t("Vente & Depense")}
                </Link>
              </Breadcrumbs>
            </div>

            {/* container formulaire */}
            <div className="flex flex-col space-y-8 justify-center md:p-10 s:p-4">
              <div className="flex md:flex-row s:flex-col  md:justify-between  ">
                {/* Somme total */}
                <div className="flex flex-row items-center justify-center space-x-2 s:text-base xs:text-xl bg-[#233D4D] xs:w-[450px] s:w-[260px] sm:w-[320px]  text-white h-20 rounded-md shadown-lg">
                  <GrMoney />
                  <div className="flex xs:flex-row s:flex-col">
                    <p>{t("Chiffre d'affaire")} : </p>
                    {/* <p className="font-bold pl-3">{somme} XOF</p> */}
                    <div className='flex flex-row items-center space-x-4'>
                          <div className='text-3xl font-bold pl-3'>{ visible && somme} FCFA</div>
                          <div className=' text-2xl' onClick={() => setVisible(!visible)}>
                                                {visible ? <EyeOutlined /> : <EyeInvisibleOutlined /> }
                          </div>
                    </div>
                  </div>
                </div>

                {/* boutton ajouter achats */}
                <div className="p-6  w-[230px]">
                  <Link to="/Dashboard/Transation/Ajouter">
                    <button className="flex flex-row items-center justify-center h-10  space-x-2 bg-[#FCCA46] text-white md:text-base s:text-sm md:w-[200px] s:w-[190px] transform active:scale-75 transition-transform">
                      <IoAddSharp />
                      <p>{t("Ajouter une transaction")}</p>
                    </button>
                  </Link>
                </div>
              </div>

              <div className="flex md:flex-row s:flex-col  md:justify-between ">
                <div className="flex items-center space-x-4">
                  <p className="text-lg">{t("Filtrer par date")} : </p>
                  <input type="date"
                          name="filteredDate"
                          className="border-none"
                          onChange={handleDateChange}
                          ref={dateRef}
                           />

                    <button
                    type="button"
                    onClick={handleReset}
                    className="ml-2 px-3 py-1 bg-gray-200 rounded hover:bg-gray-300"
                    >
                    {t("Réinitialiser")}
                    </button>
                </div>

                <div className="flex items-center space-x-4">
                  <p className="text-lg">{t("Afficher")} : </p>
                  
                  <button
                    onClick={() => handleDepense()}
                    className={`${
                      activeButton === "depense" ? "bg-[#4E4E4E] text-white" : "bg-white text-[#4E4E4E]"
                    } h-10 shadow-lg w-[130px] rounded transform active:scale-75 transition-transform`}
                    >
                    {t("Depense")}
                  </button>
                  <button
                    onClick={() => handleVente()}
                    className={`${
                      activeButton === "vente" ? "bg-[#4E4E4E] text-white" : "bg-white text-[#4E4E4E]"
                    } h-10 shadow-lg w-[130px] rounded transform active:scale-75 transition-transform`}
                  >
                    {t("Vente")}
                  </button>
                  <button
                    onClick={() => handleTransaction()}
                    className={`${
                      activeButton === "transaction" ? "bg-[#4E4E4E] text-white" : "bg-white text-[#4E4E4E]"
                    } h-10 shadow-lg w-[130px] rounded transform active:scale-75 transition-transform`}
                    >
                    Transaction
                  </button>
                </div>
              </div>

              {/* Liste des depenses et ventes */}
              {
                (activeButton === "depense" || activeButton === "vente") && (
                    <Card className="h-full w-full border-t-8 border-[#fe7f2d] ">
                        <CardHeader
                        floated={false}
                        shadow={false}
                        className="rounded-none"
                        >
                        <Typography
                            className="md:text-xl s:text-lg font-semibold"
                            color="blue-gray"
                        >
                            {t("Liste")}
                        </Typography>
                        </CardHeader>
                        <CardBody className="overflow-scroll px-0">
                        <table className="mt-4 w-full min-w-max overflow-scroll  table-auto text-left">
                            <thead>
                            <tr>
                                {TABLE_HEAD.map((head, index) => (
                                <th
                                    key={head}
                                    className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50"
                                >
                                    <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="flex items-center justify-between gap-2 font-normal leading-none opacity-70"
                                    >
                                    {head}{" "}
                                    {index !== TABLE_HEAD.length - 1 && (
                                        <ChevronUpDownIcon
                                        strokeWidth={2}
                                        className="h-4 w-4"
                                        />
                                    )}
                                    </Typography>
                                </th>
                                ))}
                            </tr>
                            </thead>
                            {recordsToDisplay.length === 0 && (
                            <tbody>
                                <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal flex items-center"
                                >
                                {t("Pas de donnees")}
                                </Typography>
                            </tbody>
                            )}
                            {recordsToDisplay.length > 0 && (
                            <tbody>
                                {recordsToDisplay.map((list, index) => {
                                const isLast = index === records.length - 1;
                                const classes = isLast
                                    ? "p-4"
                                    : "p-4 border-b border-blue-gray-50";



                                return (
                                    <tr key={index} className="hover:bg-slate-100">
                                    <td className={classes}>
                                        <Tooltip content="Action sur la publication">
                                        <IconButton variant="text">
                                            <Menu>
                                            <MenuHandler>
                                                <IconButton>
                                                <RxDotsVertical />
                                                </IconButton>
                                            </MenuHandler>
                                            <MenuList className="flex flex-col gap-2">
                                                {/* modifier */}
                                                <Link to="/Dashboard/Transation/Modifier"
                                                    state={list.id_order}
                                                    >
                                                <MenuItem className="flex items-center gap-4 py-2 pl-2 pr-8 hover:bg-gray-100">
                                                    <FiEdit className="text-lg" />
                                                    <div className="flex flex-col gap-1">
                                                    <Typography
                                                        variant="small"
                                                        color="gray"
                                                        className="font-semibold"
                                                    >
                                                        {t("Modifier")}
                                                    </Typography>
                                                    </div>
                                                </MenuItem>
                                                </Link>

                                                {/* supprimer */}
                                                <Link to="">
                                                <MenuItem className="flex items-center gap-4 py-2 pl-2 pr-8 hover:bg-gray-100">
                                                    <FcCancel className="text-lg" />
                                                    <div className="flex flex-col gap-1">
                                                    <Typography
                                                        onClick={()=>handleDelete(list.id_order,authUser?.userId)}
                                                        variant="small"
                                                        color="gray"
                                                        className="font-semibold"
                                                    >
                                                        {t("supprimer")}
                                                    </Typography>
                                                    </div>
                                                </MenuItem>
                                                </Link>
                                            </MenuList>
                                            </Menu>
                                        </IconButton>
                                        </Tooltip>
                                    </td>
                                    <td className={classes}>
                                        <div className="flex items-center space-x-2 ">
                                        <div className="flex flex-col">
                                            <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal"
                                            >
                                            {list?.type === 1 ? 'Depense' : 'Vente'}
                                            </Typography>

                                        </div>
                                        </div>
                                    </td>

                                    <td className={classes}>
                                        <div className="flex flex-col">
                                        <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal"
                                        >
                                            {list?.names } {list?.lastname ?? ''}
                                        </Typography>
                                        {/* <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal"
                                        >
                                            {list?.fr_title}
                                        </Typography> */}
                                        </div>
                                    </td>
                                    <td className={classes}>
                                        <div className="flex flex-col">
                                        <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal"
                                        >
                                            {list?.description}
                                        </Typography>
                                        {/* <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal"
                                        >
                                            {lieu}
                                        </Typography> */}
                                        </div>
                                    </td>
                                    <td className={classes}>
                                        <div className="w-max">
                                        <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal"
                                        >
                                            {new Date(list?.date).toLocaleDateString(
                                                "fr-FR"
                                            )}

                                        </Typography>
                                        </div>
                                    </td>

                                    <td className={classes}>
                                        <div className="w-max">
                                        <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal"
                                        >
                                            {list?.unique_price} XOF
                                        </Typography>
                                        </div>
                                    </td>

                                    </tr>
                                );
                                })}
                            </tbody>
                            )}
                        </table>
                        </CardBody>
                        <CardFooter className="flex items-center justify-between border-t border-blue-gray-50 p-4">
                        <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal"
                        >
                            Page {currentPage} of {totalPages}
                        </Typography>
                        <div className="flex gap-2">
                            <Button variant="outlined" 
                                    size="sm"
                                    onClick={prevPage}
                                    disabled={currentPage === 1}
                                    >
                            {t("Previous")}
                            </Button>
                            <Button variant="outlined"
                                    size="sm"
                                    onClick={nextPage}
                                    disabled={currentPage === totalPages}
                                    >
                            {t("Next")}
                            </Button>
                        </div>
                        </CardFooter>
                    </Card>
                )
              }
              

              {/* Transactions */}
              {
                activeButton === "transaction"  && (
                     <div className='flex justify-center md:p-10 s:p-4'>
              
                        <Card className="h-full w-full border-t-8 border-[#fe7f2d] ">
                            <CardHeader floated={false} shadow={false} className="rounded-none">
                                <Typography className='md:text-xl s:text-lg font-semibold' color="blue-gray">
                                Historique des transactions 
                                </Typography>
                            </CardHeader>
                            <CardBody className="overflow-scroll px-0">
                                <table className="mt-4 w-full min-w-max overflow-scroll  table-auto text-left">
                                    <thead>
                                        <tr>
                                            {TABLE_HEAD_TRANSACTION.map((head, index) => (
                                                <th
                                                    key={head}
                                                    className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50"
                                                >
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="flex items-center justify-between gap-2 font-normal leading-none opacity-70"
                                                    >
                                                        {head}{" "}
                                                        {index !== TABLE_HEAD.length - 1 && (
                                                            <ChevronUpDownIcon strokeWidth={2} className="h-4 w-4" />
                                                        )}
                                                    </Typography>
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {recordsToDisplay.map(
                                            (trans, index) => {
                                                const isLast = index === transactions.length - 1;
                                                const classes = isLast
                                                    ? "p-4"
                                                    : "p-4 border-b border-blue-gray-50";

                                                return (
                                                    <tr key={trans.Names} className='hover:bg-slate-100'>

                                                        <td className={classes}>
                                                            <div className="flex items-center space-x-2 ">
                                                                <div className="flex flex-col">
                                                                    <Typography
                                                                        variant="small"
                                                                        color="blue-gray"
                                                                        className="font-normal"
                                                                    >
                                                                        {trans.Names}
                                                                    </Typography>
                                                                    <Typography
                                                                        variant="small"
                                                                        color="blue-gray"
                                                                        className="font-normal opacity-70"
                                                                    >
                                                                        {trans.email}
                                                                    </Typography>
                                                                    <Typography
                                                                        variant="small"
                                                                        color="blue-gray"
                                                                        className="font-normal opacity-70"
                                                                    >
                                                                        {trans.Phones}
                                                                    </Typography>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className={classes}>
                                                            <div className="flex flex-col">
                                                                <Typography
                                                                    variant="small"
                                                                    color="blue-gray"
                                                                    className="font-normal"
                                                                >
                                                                    {new Date(trans.date).toLocaleString('fr-FR', {
                                                                            day: '2-digit',
                                                                            month: '2-digit',
                                                                            year: 'numeric',
                                                                            hour: '2-digit',
                                                                            minute: '2-digit',
                                                                    })}

                                                                </Typography>
                                                            </div>
                                                        </td>
                                                        <td className={classes}>
                                                            <Typography
                                                                variant="small"
                                                                color="blue-gray"
                                                                className="font-normal"
                                                            >
                                                                {trans.amount} XOF
                                                            </Typography>
                                                        </td>
                                                        <td className={classes}>
                                                            <Typography
                                                                variant="small"
                                                                color="blue-gray"
                                                                className="font-normal"
                                                            >
                                                                {trans.title_announce ? trans.title_announce :  "Rechargement de Carte  AZ"} 
                                                            </Typography>
                                                        </td>
                                                            <td className={classes}>
                                                            <Typography
                                                                variant="small"
                                                                color="blue-gray"
                                                                className="font-normal"
                                                            >
                                                                {trans.note ? trans.note :  "Rechargement de Carte  AZ"} 
                                                            </Typography>
                                                        </td>
                                                        <td className={classes}>
                                                            <Typography
                                                                variant="small"
                                                                color="blue-gray"
                                                                className="font-normal"
                                                            >
                                                                {"recu"}
                                                            </Typography>
                                                        </td>
                                                        <td className={classes}>
                                                            <Tooltip content="Action sur la publication">
                                                                <IconButton variant="text">
                                                                    <Menu>
                                                                        <MenuHandler>
                                                                            <IconButton>
                                                                                <RxDotsVertical />
                                                                            </IconButton>
                                                                        </MenuHandler>
                                                                        <MenuList className="flex flex-col gap-2">
                                                                            {/* Refuser */}
                                                                            <Link to="">
                                                                                <MenuItem className="flex items-center gap-4 py-2 pl-2 pr-8 hover:bg-gray-100">
                                                                                    <FcCancel className='text-lg' />
                                                                                    <div className="flex flex-col gap-1">
                                                                                        <Typography variant="small" color="gray" className="font-semibold">
                                                                                            Suprimer
                                                                                        </Typography>
                                                                                    </div>
                                                                                </MenuItem>
                                                                            </Link>
                                                                        </MenuList>
                                                                    </Menu>
                                                                </IconButton>
                                                            </Tooltip>
                                                        </td>
                                                    </tr>
                                                );
                                            },
                                        )}
                                    </tbody>
                                </table>
                            </CardBody>
                            <CardFooter className="flex items-center justify-between border-t border-blue-gray-50 p-4">
                                <Typography variant="small" color="blue-gray" className="font-normal">
                                    Page {currentPage} of {totalPages}
                                </Typography>
                                <div className="flex gap-2">
                                    <Button variant="outlined"
                                            size="sm"
                                            disabled={currentPage === 1}
                                            onClick={prevPage}
                                            >
                                        Previous
                                    </Button>
                                    <Button variant="outlined" 
                                            size="sm"
                                            disabled={currentPage === totalPages}
                                            onClick={nextPage}
                                            >
                                        Next
                                    </Button>
                                </div>
                            </CardFooter>
                        </Card>
                    
                    </div>
                )
              }
              
             
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Liste;
